package twist.mena.sports.shared.dto.admin.legacy

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminLegacyEntityResponse(
    val id: String,
    @SerialName("legacy_id") val legacyId: String?,
    @SerialName("name_en") val nameEn: String?,
    @SerialName("name_ar") val nameAr: String?,
    @SerialName("image_url") val imageUrl: String?,
    @SerialName("display_order") val displayOrder: Int,
    @SerialName("is_hidden") val isHidden: Boolean,
    @SerialName("hidden_at_utc") val hiddenAtUtc: String?,
    @SerialName("has_missing_translation") val hasMissingTranslation: Boolean,
    @SerialName("created_at_utc") val createdAtUtc: String,
    @SerialName("updated_at_utc") val updatedAtUtc: String
)
